import Vue from "vue";

import comboComponent from "@/components/child/form/combo.vue";
import decimalComponent from "@/components/child/form/decimal.vue";
import decimalComSinalCustomComponent from "@/components/child/form/decimalComSinalCustom.vue";
import { Component, Watch } from "@/decorators";
import StatusProdutoLote from "@/models/enum/statusProdutoLote";
import ProdutoLoteModel from "@/models/produtoLoteModel";
import preVendaService from "@/services/preVendaService";
import ProdutoLoteService from "@/services/produtoLoteService";
import Delay from "@/utils/common/delay";

import ShortcutComponent from "../../shortcut/shortcut";
import shortcutComponent from "../../shortcut/shortcut.vue";

import "../crud.scss";

@Component({
    components: {
        comboComponent,
        decimalComponent,
        decimalComSinalCustomComponent,
        shortcutComponent,
    },
})
export default class AtualizarStatusEditComponent extends Vue {
    private service = new ProdutoLoteService();
    private shortcutComponent: ShortcutComponent = null;

    produtoLoteModel = new ProdutoLoteModel();
    statusProdutoLoteOptions = [];
    newStatusProdutoLote: StatusProdutoLote = null;

    public async show(model: ProdutoLoteModel, isEstereis = false) {
        this.produtoLoteModel.updateFrom(model);

        this.statusProdutoLoteOptions = new ProdutoLoteModel().getStatusProdutoLoteOptions(isEstereis);

        if (this.produtoLoteModel.statusProdutoLote == StatusProdutoLote.AguardandoAprovacaoAnvisa) {
            this.statusProdutoLoteOptions = this.statusProdutoLoteOptions.filter(
                p =>
                    p["value"] == StatusProdutoLote.Liberado ||
                    p["value"] == StatusProdutoLote.AguardandoAprovacaoAnvisa,
            );
        }

        while (!this.$refs.shortcutComponent) await Delay(100);
        this.shortcutComponent = this.$refs.shortcutComponent as ShortcutComponent;

        this.shortcutComponent.title = `Atualizar status do lote ${this.produtoLoteModel.descricao}`;

        this.shortcutComponent.show();
    }

    private async onAtualizarStatus() {
        try {
            const isValid = await this.$validator.validateAll();
            if (isValid) {
                let liberarVendasComLoteEmAnalise = false;
                if (
                    this.produtoLoteModel.statusProdutoLote == StatusProdutoLote.AguardandoAprovacaoAnvisa &&
                    this.newStatusProdutoLote != StatusProdutoLote.AguardandoAprovacaoAnvisa
                ) {
                    const produtoLoteComPreVenda = await preVendaService.checkPreVendaByProdutoId(
                        this.produtoLoteModel.produtoId,
                    );

                    if (produtoLoteComPreVenda) {
                        liberarVendasComLoteEmAnalise = await this.$showQuestion(
                            this.$t("__.ts.atencao"),
                            this.$t("__.Crud.produtolote.atualizarStatus_vue_html.desejaLiberarLote"),
                        );

                        if (!liberarVendasComLoteEmAnalise) {
                            this.newStatusProdutoLote = StatusProdutoLote.AguardandoAprovacaoAnvisa;
                            return;
                        }
                    }
                }

                const sucesso = await this.service
                    .updateStatus(this.produtoLoteModel.id, this.newStatusProdutoLote)
                    .withLoading()
                    .resolveWithoutJSON();

                if (sucesso) {
                    const usuarioDestinoId = 165; //Renata do fracionamento

                    if (this.newStatusProdutoLote === StatusProdutoLote.Liberado) {
                        await this.$notifyOtherUser(
                            usuarioDestinoId,
                            `Lote ${this.produtoLoteModel.descricao} do produto ${this.produtoLoteModel.produtoDescricao} liberado para venda.`,
                            "Lote liberado",
                        );
                    }

                    await this.$showSuccess(
                        this.$t("__.ts.sucesso"),
                        this.$t("__.Crud.produtolote.atualizarStatus_vue_html.atualizadoSucesso"),
                    );

                    if (liberarVendasComLoteEmAnalise) {
                        const response = await preVendaService.liberarVendasComLoteEmAnaliseByProdutoLoteId(
                            this.produtoLoteModel.id,
                        );

                        this.mostrarVendasAlteradas(response);
                    }

                    this.$emit("onStatusSucesso");
                    this.shortcutComponent.hide();
                }
            }
        } catch {}
    }

    @Watch("produtoLoteModel.id")
    private onChangeProtudoLoteId() {
        this.newStatusProdutoLote = null;
    }

    private async mostrarVendasAlteradas(ArrayVendas: Array<any>) {
        if (ArrayVendas.length > 0) {
            let message = "";

            const hasItensNaoAlterados = ArrayVendas.filter(p => p.atualizadoAutomaticamente === false).length > 0;

            if (ArrayVendas.filter(p => p.atualizadoAutomaticamente).length > 0) {
                message +=
                    "A(s) seguinte(s) venda(s) tiveram seus status alterados: " +
                    ArrayVendas.filter(p => p.atualizadoAutomaticamente)
                        .map(v => `${v.codigo}`)
                        .join(", ");

                if (hasItensNaoAlterados) message += "\n";
            }

            if (hasItensNaoAlterados) {
                message +=
                    "Não foi possível alterar a(s) seguinte(s) venda(s): " +
                    ArrayVendas.filter(p => p.atualizadoAutomaticamente === false)
                        .map(v => `${v.codigo}(${v.descricaoErro})`)
                        .join(", ");
            }

            await this.$showWarning(this.$t("__.ts.aviso"), message);
        }
    }
}
